
const authentication = require('../../../react-azure-adb2c2').default;



export const list = (values: any) => {

    // const url = `http://localhost:5000/v1/t/room/stocks/list`;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/t/room/stocks/list`;


    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(search),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const insert = (values: any) => {


    const url = process.env.REACT_APP_API_CRM_URL + `/v1/t/room/stocks/insert/`;
    // const url = `http://localhost:5000/v1/t/room/stocks/insert/`;



    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};



export const stockdelete = (values: any) => {

    // const url = `http://localhost:5000/v1/t/room/stocks/delete/` + values;

    const url = process.env.REACT_APP_API_CRM_URL + `/v1/t/room/stocks/delete/` + values;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'DELETE',
        // body: JSON.stringify(search),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};




export const stockdeleteall = (values: any) => {

    // const url = `http://localhost:5000/v1/t/room/stocks/delete/` + values;

    const url = process.env.REACT_APP_API_CRM_URL + `/v1/t/room/stocks/deleteall/`;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'DELETE',
        // body: JSON.stringify(search),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};